import { createAsyncThunk } from "@reduxjs/toolkit";
import { createDealApi, fetchDealsApi, fetchLeadsApi, leadActionApi, updateDealMetaApi, updateDealStageApi } from "../../../apiservice/crm";

export const fetchDeals = createAsyncThunk(
  "deals/fetchDeals",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchDealsApi({});
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const createDeal = createAsyncThunk(
  "deals/createDeal",
  async (payload, { getState, rejectWithValue }) => {
    try {
      await createDealApi(payload);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateDealMeta = createAsyncThunk(
  "deals/updateMeta",
  async (payload, { rejectWithValue }) => {
    try {
      await updateDealMetaApi(payload);
      return payload; // 🔥 return for optimistic update
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateDealStage = createAsyncThunk(
  "deals/updateStage",
  async (payload, { rejectWithValue }) => {
    try {
      await updateDealStageApi(payload);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);